import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Leaf, LayoutDashboard, BookOpen, LogOut, Shield, Users } from "lucide-react";

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    sessionStorage.removeItem("nt_admin_token");
    navigate("/admin");
  };

  const navItems = [
    { label: "Vezérlőpult", icon: LayoutDashboard, path: "/admin/dashboard" },
    { label: "Kurzusok", icon: BookOpen, path: "/admin/dashboard" },
    { label: "Felhasználói Haladás", icon: Users, path: "/admin/progress" },
  ];

  return (
    <div className="flex min-h-screen" style={{ background: "#FDF5EB", fontFamily: "Quicksand, sans-serif" }}>
      {/* Sidebar */}
      <aside
        className="w-64 fixed top-0 left-0 h-full flex-col hidden lg:flex"
        style={{ background: "#242220", borderRight: "1.5px solid #242220" }}
      >
        <div className="flex items-center gap-3 px-5 py-6 mb-4" style={{ borderBottom: "1.5px solid #444" }}>
          <div
            className="w-9 h-9 flex items-center justify-center flex-shrink-0"
            style={{ background: "#FBD556", borderRadius: "12px" }}
          >
            <Leaf size={16} color="#242220" strokeWidth={2.5} />
          </div>
          <div>
            <p className="font-bold text-sm leading-tight" style={{ color: "#FDF5EB" }}>NaturTrak LMS</p>
            <div className="flex items-center gap-1 mt-0.5">
              <Shield size={10} color="#FF9456" strokeWidth={2.5} />
              <p className="text-xs" style={{ color: "#FF9456" }}>Admin</p>
            </div>
          </div>
        </div>

        <nav className="flex-1 px-3 space-y-1">
          {navItems.map((item) => {
            const active = location.pathname === item.path;
            return (
              <Link
                key={item.label}
                to={item.path}
                className="flex items-center gap-3 px-4 py-3 rounded-2xl font-bold text-sm transition-all"
                style={{
                  background: active ? "#FBD556" : "transparent",
                  color: active ? "#242220" : "#FDF5EB",
                  textDecoration: "none",
                  border: active ? "1.5px solid #FBD556" : "1.5px solid transparent",
                }}
                data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                <item.icon size={17} strokeWidth={2.5} />
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 mt-auto">
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 py-2.5 font-bold text-sm"
            style={{
              background: "transparent",
              borderRadius: "20px",
              border: "1.5px solid #555",
              color: "#FDF5EB",
              cursor: "pointer",
            }}
            data-testid="admin-logout-btn"
          >
            <LogOut size={15} strokeWidth={2.5} />
            Kijelentkezés
          </button>
        </div>
      </aside>

      {/* Mobile header */}
      <div
        className="lg:hidden fixed top-0 left-0 right-0 z-40 flex items-center justify-between px-4 py-3"
        style={{ background: "#242220", borderBottom: "1.5px solid #444" }}
      >
        <div className="flex items-center gap-2">
          <Leaf size={16} color="#FBD556" strokeWidth={2.5} />
          <span className="font-bold text-sm" style={{ color: "#FDF5EB" }}>NaturTrak Admin</span>
        </div>
        <button onClick={handleLogout} style={{ color: "#FDF5EB" }}>
          <LogOut size={18} strokeWidth={2.5} />
        </button>
      </div>

      <main className="flex-1 lg:ml-64 pt-14 lg:pt-0">
        <div className="p-4 lg:p-8">{children}</div>
      </main>
    </div>
  );
}
